import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`About`}</h1>
    <p>{`Hey everyone, I'm Chirag Goel, Freshman at MAIT CSE. Passionate about computers, tech savvy, love interacting with new people.
I am currently working my way up to become a great competitive coder, learning, understanding and strengthening.
Apart from CP ,I'm always looking for something new or creating some project that are more creative and reliable for the user.`}</p>
    <p>{`I create and design Web Apps.....:)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      